import moment from 'moment'
var numeral = require('numeral');
numeral.register('locale', 'es', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal : function (number) {
        return number === 1 ? 'o' : 'os';
    },
    currency: {
        symbol: '$'
    }
});

// switch between locales
numeral.locale('es');

export default {
    methods: {
        $formatDate(date) {
        if (!date) return ""
            let xdate = new Date(date)
            let m = moment(xdate)
            return m.format("DD/MM/YY")
        },
        $formatTime(time) {
        if (!time) return ""
            let date = new Date(time.replace("0000-00-00","1900-01-01"))
            let m = moment(date)
            return m.format("HH:mm:ss")
        },
        $formatNumber(x) {
            if (x==null||x==undefined) return ""
            if (isNaN(x)) return ""
            return new numeral(x).format('0,0.00');
        },
        $formatNumber0(x) {
            if (x==null||x==undefined) return ""
            if (isNaN(x)) return ""
            return new numeral(x).format('0,0');
        },        
        $calcularDiferenciaMeses(fecha1, fecha2) {
            // Convertir las cadenas de fecha a objetos de fecha
            var date1 = new Date(fecha1);
            var date2 = new Date(fecha2);
        
            // Calcular la diferencia en milisegundos
            var diferenciaEnMilisegundos = Math.abs(date2 - date1);
        
            // Convertir la diferencia a meses
            var meses = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24 * 30.44);
        
            // Verificar si la diferencia es mayor a 1 mes
            return meses <= 1;
        }
    },
};